var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { ModalContext } from '../ModalContext';
const getModalId = () => Date.now().toString();
/**
 * TODO: https://lucidlink.atlassian.net/browse/LUCID-22290
 * Currently the Modal doesn't update when its props do.
 */
/**
 * By default the modal will close on navigating.
 *
 * By default the modal will not close on parent
 * (Component from which the modal is being opened) unmount.
 *
 * By default there is no need to provide modalId.
 * You can provide it if you need to be able
 * to close the modal from another place in the
 * app tree.
 */
export const useModal = ({ closeOnNavigate = true, closeOnUnmount, modalId, onStateChange, } = {}) => {
    _react_refresh_temp_1();
    const { closeModal: closeModalFromContext, isModalOpen: isModalOpenFromContext, openModal: openModalFromContext, updateModal: updateModalFromContext, } = useContext(ModalContext);
    const modalIdRef = useRef(modalId ?? getModalId());
    const isModalOpen = useCallback(() => isModalOpenFromContext(modalIdRef.current), [isModalOpenFromContext]);
    const closeModal = useCallback(() => {
        closeModalFromContext(modalIdRef.current);
        if (onStateChange) {
            onStateChange({ action: 'close', modalId: modalIdRef.current });
        }
    }, [closeModalFromContext, onStateChange]);
    const openModal = useCallback(({ content }) => {
        openModalFromContext({
            closeOnNavigate,
            content,
            modalId: modalIdRef.current,
        });
        if (onStateChange) {
            onStateChange({ action: 'open', modalId: modalIdRef.current });
        }
    }, [closeOnNavigate, onStateChange, openModalFromContext]);
    const updateModal = useCallback(({ closeOnNavigate: clsOnNvg, content, newModalId, }) => {
        // The provider refuses a rename to its own or another open modal's id
        const canRename = newModalId !== undefined &&
            newModalId !== modalIdRef.current &&
            !isModalOpenFromContext(newModalId);
        updateModalFromContext({
            closeOnNavigate: clsOnNvg ?? closeOnNavigate,
            content,
            modalId: modalIdRef.current,
            ...(newModalId && { newModalId }),
        });
        if (canRename) {
            modalIdRef.current = newModalId;
        }
        if (onStateChange) {
            onStateChange({
                action: 'update',
                modalId: modalIdRef.current,
            });
        }
    }, [
        closeOnNavigate,
        isModalOpenFromContext,
        onStateChange,
        updateModalFromContext,
    ]);
    useEffect(() => {
        return () => {
            if (closeOnUnmount) {
                closeModal();
            }
        };
    }, [closeModal, closeOnUnmount]);
    return useMemo(() => ({
        closeModal,
        isModalOpen,
        openModal,
        updateModal,
    }), [closeModal, isModalOpen, openModal, updateModal]);
};
_react_refresh_temp_1(useModal, "O/JWiRkMl9esE4WvSw8JAm06d1A=");
